'use client';

import { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

import Loading from '@/app/loading';
import { ItemsGrid } from '@/components/ItemsGrid';
import {
  MIN_INTERVAL,
  useRefreshContent,
} from '@/components/RefreshContent/useRefreshContent';
import { useComscorePageview, useFetchFeed } from '@/hooks';
import { IPaginatedItem } from '@/types/feed.types';
import { filterByExclusion } from '@/utils/array';

import { IItems } from '../Items/Items.types';

export const Items: React.FC<IItems> = ({ playlistId, noResultsTitle }) => {
  useComscorePageview(playlistId);

  const { ref, inView } = useInView();

  // Interval Ref to be used as the refetchInterval in useQuery
  const interval = useRef<number>(MIN_INTERVAL);

  const {
    itemList,
    hasNextUrl,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
  } = useFetchFeed({ playlistId, interval: interval.current });

  const filteredData = filterByExclusion<IPaginatedItem>(
    itemList,
    'categories',
    'publicidad',
  );

  const { currentData } = useRefreshContent(interval, filteredData, false);

  useEffect(() => {
    if (inView && hasNextPage && hasNextUrl) {
      fetchNextPage?.();
    }
  }, [inView, hasNextPage, hasNextUrl, fetchNextPage]);

  if (isLoading) return <Loading />;

  return (
    <ItemsGrid
      items={currentData}
      lastItemRef={ref}
      isLoading={isFetching}
      noResultsTitle={noResultsTitle}
      playlistId={playlistId}
      previewSource="category"
    />
  );
};
